export const isSoulCloserEnabled = value =>
  value === true || value === 'true' || value === '1';

export const buildSoulCloserDraft = (integration, legacyPersonality = '') => {
  const values = { ...(integration?.settings || {}) };
  const shouldPrefillLegacyPersonality =
    !values.soul_closer_personality &&
    !integration?.configured &&
    Boolean(legacyPersonality);

  if (shouldPrefillLegacyPersonality) {
    values.soul_closer_personality = legacyPersonality;
  }

  return {
    values,
    prefilledFromGeneralPersonality: shouldPrefillLegacyPersonality,
  };
};

export const buildSoulCloserSettingsPayload = (fields, draft) =>
  Object.fromEntries(
    (fields || []).map(field => [field.key, draft[field.key]])
  );
